const state = {
    apiEndpoint: localStorage.API_URL + '/SMLJavaWebService/webresources/rest/',
    apiUrl: localStorage.API_URL,
    endpointPath: '/SMLJavaWebService/webresources/rest/',
    provider: localStorage.PROVIDER,
    database: localStorage.DATABASE
}

const getters = {
    getApiUrl: state => {
        return state.apiUrl
    }
}

// actions
const actions = {
    setSource({ commit }, {apiUrl, provider, database} ) {
        commit("setSource", {apiUrl, provider, database})
    },
}

// mutations
const mutations = {
    setSource(state, {apiUrl, provider, database}) {
        state.apiUrl = apiUrl
        state.provider = provider
        state.database = database
        state.apiEndpoint = apiUrl + state.endpointPath
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}